import { Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import LikutSectionMain from '../likutSection/LikutSectionMain'
import SiumLikutModal from './siumLikut/SiumLikutModal'
import { AppModal } from '../../../../../generic/ui/Modal'
import { LINKS, relPath } from '../../../../../Routs/config'
import PalletsToChange from '../../../../../generic/modals/PalletsToChange'
import LikutModalsProvider from '../modalsForLikut/LikutModalsProvider'
import LikutPageLayout from '../Components/LikutPageLayout'
import PalletSelectBar from './Components/PalletSelectBar'
import LikutScrollArea from '../Components/LikutScrollArea'
import LikutPalletRow from './Components/LikutPalletRow'
import PalletActionDock from './Components/PalletActionDock'
import ModalSelectDriver from './Components/ModalSelectDriver'
import ModalTeudaCreated from './Components/ModalTeudaCreated'
import { IPalletTypeItem } from '../../../../../modules/API/Defaults/models/pallets'
import usePalletSection from './services/hooks/usePalletSection'

interface Props {
    palletList?: IPalletTypeItem[];
    azmanaNum?: number | null;
    handleFetchOrders?: () => void;
}

function LikutExpressPalletSectionBody({ palletList = [], azmanaNum, handleFetchOrders }: Props) {
    const [t] = useTranslation(['likut'])

    const {
        palletAzmana,
        activeArizotCalc,
        palletQtySum,
        handleOpenPallet,
        tempTeudaData,
        isOpenPrintWindow,
        printTeuda,
        finishTeuda,
        checValidDataForTeuda,
        isOpenSelectDriver,
        handleSelectDriverModal,
        setIsAutomaticSaveTeuda,
        carList,
        defaultCar,
        handleSaveCarID,
        chekLikut,
        clientID,
        inputClients,
        defaultClientList,
        selectedCustomer,
        handleSelectClient,
        setDate,
        siumModalIsOpen,
        setSiumModalIsOpen,
        azmanotListForSiumLikut,
        azmanaDetails,
        siumLikut,
        getAzmanotDetailes,
        isWeightCalculation,
        defaultPackageList,
        selectedPalletTypeItem,
        handleSelectPalletType,
        isOpenModalPallets,
        handleControlPalletModal,
        palletModalProps,
        printerState,
        defaultPrinterNum,
        handleOpenPrinterSettings,
        handleClickPrint,
        printPallet,
        handleNewPallet,
        handleBack,
        getPallet,
        getExistPalletInfo,
        numMishtah,
        likutInfo,
    } = usePalletSection({ azmanaNum, palletList, handleFetchOrders })

    const isEmpty = !palletAzmana || palletAzmana.length < 1
    const lastIndex = (palletAzmana?.length ?? 0) - 1
    const showPrimaryAction = chekLikut ? !!clientID && palletAzmana?.length > 0 : true

    return (
        <Routes>
            <Route index element={
                <LikutPageLayout title={t('likut_pallets_title')}>
                    {
                        isOpenModalPallets &&
                        <AppModal
                            title={`${azmanaNum || likutInfo.azmanaNum} הזמנה`}
                            controlFunc={handleControlPalletModal}
                            Children={PalletsToChange}
                            childrenProps={palletModalProps}
                            size='md'
                        />
                    }
                    {
                        isOpenPrintWindow &&
                        <AppModal
                            title={`№ ${tempTeudaData?.deliveryNum}`}
                            controlFunc={finishTeuda}
                            Children={ModalTeudaCreated}
                            childrenProps={{
                                onPrint: printTeuda,
                                onFinish: finishTeuda,
                            }}
                            size='sm'
                        />
                    }
                    {
                        isOpenSelectDriver &&
                        <AppModal
                            title='בחר נהג'
                            controlFunc={handleSelectDriverModal}
                            Children={ModalSelectDriver}
                            childrenProps={{
                                cars: carList,
                                defaultCar: defaultCar,
                                onSave: handleSaveCarID,
                            }}
                            size='sm'
                        />
                    }
                    {siumModalIsOpen &&
                        <AppModal
                            title={t('likut_modal_sium_likut_title')}
                            controlFunc={() => setSiumModalIsOpen(false)}
                            Children={SiumLikutModal}
                            childrenProps={{
                                azmanotListForSiumLikut,
                                azmanaDetails,
                                defaultPackageList,
                                siumLikut,
                                siumModalIsOpen,
                                setSiumModalIsOpen,
                                isWeightCalculation,
                                palletModalProps: {
                                    ...palletModalProps,
                                    callback: () => {
                                        siumLikut()
                                    }
                                }
                            }}
                            size='md'
                        />
                    }

                    <BarRow>
                        <PalletSelectBar
                            chekLikut={!!chekLikut}
                            clientID={clientID}
                            setDate={setDate}
                            customers={defaultClientList}
                            selectedCustomer={selectedCustomer}
                            onSelectClient={handleSelectClient}
                            palletTypes={palletList}
                            selectedPalletType={selectedPalletTypeItem}
                            onSelectPalletType={handleSelectPalletType}
                            showPrintTeuda={!!tempTeudaData}
                            onPrintTeuda={printTeuda}
                            onOpenDriver={() => {
                                setIsAutomaticSaveTeuda(false)
                                handleSelectDriverModal()
                            }}
                            onOpenPrinterSettings={handleOpenPrinterSettings}
                            palletQtySum={palletQtySum}
                            onOpenPalletsModal={handleControlPalletModal}
                        />
                    </BarRow>
                    {isEmpty ? (
                        <EmptyState>
                            <img src='/images/no-data.png' alt='empty data' />
                        </EmptyState>
                    ) : (
                        <LikutScrollArea>
                            {palletAzmana.map((pallet, idx) => (
                                <LikutPalletRow
                                    key={pallet.Pallet_Num}
                                    pallet={pallet}
                                    index={idx}
                                    interactive={pallet.CheckTime === '000000' || likutInfo.azmanaStatus === 7}
                                    onOpen={() => handleOpenPallet(pallet, idx)}
                                    onPrint={handleClickPrint}
                                    isLast={idx === lastIndex}
                                />
                            ))}
                        </LikutScrollArea>
                    )}
                    <PalletActionDock
                        newPalletLabel={t('likut_pallets_button_new')}
                        onNewPallet={handleNewPallet}
                        primaryLabel={!chekLikut ? t('likut_pallets_button_save') : 'צור משלוח'}
                        onPrimary={!chekLikut ? () => { getAzmanotDetailes(likutInfo.azmanaNum) } : checValidDataForTeuda}
                        showPrimary={showPrimaryAction}
                        showBack={!chekLikut}
                        onBack={handleBack}
                    />
                </LikutPageLayout>
            }/>
            <Route
                path={relPath(LINKS.likut.likutExperess.likutWorkSection, LINKS.likut.likutExperess.palletSection)}
                element={<LikutSectionMain
                    getPallet={getPallet}
                    getExistPalletInfo={getExistPalletInfo}
                    printPallet={printPallet}
                    setPrintersModal={handleOpenPrinterSettings}
                    printerNum={printerState.printerID || defaultPrinterNum()}
                    numMishtah={numMishtah}
                    palletAzmana={palletAzmana}
                    activeArizotCalc={activeArizotCalc}
                />}
            />

        </Routes>
    )
}

export default function LikutExpressPalletSection(props: Props) {
    return (
        <LikutModalsProvider>
            <LikutExpressPalletSectionBody {...props} />
        </LikutModalsProvider>
    )
}

const BarRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`;

const EmptyState = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
`;
